<div class="app-body">
  <main class="main d-flex align-items-center">
    <div class="container">
      <br>
      <br>
      <br>
      <br>
      <br>



      <div *ngIf="!hidelogin">
        <div class="row">


          <div class="col-md-8 mx-auto">

            <div class="card-group">
              <div class="card p-4">

                <div style="text-align: center">
                  <h1>
                    <font color="#005b9d"> {{'resetpassword.TranslationSection.text1' | translate}}</font>
                  </h1>
                </div>


                {{'resetpassword.TranslationSection.text2' | translate}}<br><br>

                <ul>
                  <li><b>{{'resetpassword.TranslationSection.text3' | translate}}</b></li>
                  <li><b>{{'resetpassword.TranslationSection.text4' | translate}}</b></li>
                  <li><b>{{'resetpassword.TranslationSection.text5' | translate}}</b></li>
                  <li><b>{{'resetpassword.TranslationSection.text6' | translate}}</b></li>
                </ul>



                <div class="card-body">

                  <form [formGroup]="ResetForm" (ngSubmit)="resetpword(ResetForm.value)">
                    <h1>{{'resetpassword.TranslationSection.text7' | translate}}</h1>


                    <div class="input-group mb-4">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="icon-user"></i></span>
                      </div>
                      <input type="password" class="form-control" formControlName="Password" placeholder="{{'resetpassword.TranslationSection.text8' | translate}}"
                        autocomplete="current-password">
                      <div style="color: red;" *ngIf="f.Password.errors?.minlength">{{'resetpassword.TranslationSection.text10' | translate}}</div>

                    </div>
                    <div class="input-group mb-4">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="icon-lock"></i></span>
                      </div>
                      <input type="password" class="form-control" formControlName="ConfirmPassword"
                        placeholder="{{'resetpassword.TranslationSection.text9' | translate}}" autocomplete="confirm-password" >

                      <mat-error *ngIf="ResetForm.hasError('notSame')">
                        {{'resetpassword.TranslationSection.text11' | translate}}
                      </mat-error>
                    </div>



                    <div class="row">
                      <div class="col-6">
                        <!--<button type="submit" class="btn btn-primary px-4">Login</button>
                        <button mat-button matStepperNext type="button">Forgot Password</button>-->

                        <button type="submit" class="btn btn-primary px-4">{{'resetpassword.TranslationSection.text12' | translate}}</button>

                      </div>



                      <div id="loadimage">
                        <img *ngIf="loading" style="width:40px; height:40px;"
                          src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>



      <div *ngIf="!hideconfirm">

        <div class="row">


          <div class="col-md-8 mx-auto">


            <div class="card-group">
              <div class="card p-4">


                <div class="card-body">

                  <div style="text-align: center">
                    <h1>
                      <font color="#005b9d">{{'resetpassword.TranslationSection.text13' | translate}}</font>
                    </h1>
                  </div>

                  <p>
                    {{'resetpassword.TranslationSection.text14' | translate}} <a href="{{enrollURL}}/#/login">{{'resetpassword.TranslationSection.text15' | translate}}</a>
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>







    </div>
  </main>
</div>
